import { TEMPLATE_GLOBAL } from 'src/commons/constants';

export const isGlobalTemplate = (template) => {
  return template && template.templateType && template.templateType.startsWith(TEMPLATE_GLOBAL);
};
